import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OtherService } from 'src/app/services/other.service';
import { BusyService } from 'src/app/services/busy.service';
import { AccountService } from 'src/app/services/account.service';
import Swal from 'sweetalert2';
import axios from "src/app/services/axios";
import * as moment from 'moment-jalaali';
import { MapService } from 'src/app/services/map.service';
import { PersianNumberService } from 'ngx-persian';

declare let $: any;

@Component({
  selector: 'app-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.css']
})

export class PartnerDashboardComponent implements OnInit {
  passwordStrength = '';
  passwordStrengthMessage = '';
  list_City: any = [];
  lst_GroupCar: any = [];
  list_MobileGroup: any[] = [];
  list_Reason: any[] = [];
  list_ReliefType: any[] = [];
  list_MobileType: any[] = [];
  lst_Menu = [
    {
      strTitle: 'ثبت درخواست',
      strImage: '../../../../assets/imgs/new-employee.png',
      routerLink: '/partners/dashboard',
      iAction: 2
    },
    {
      strTitle: 'درخواست های من',
      strImage: '../../../../assets/imgs/road-trip.png',
      routerLink: '/partners/my-trips'
    },
    {
      strTitle: 'گزارش مالی',
      strImage: '../../../../assets/imgs/analysis.png',
      routerLink: '/partners/financial-report'
    },
    {
      strTitle: 'تغییر رمز عبور',
      strImage: '../../../../assets/imgs/reset-password.png',
      routerLink: '/partners/dashboard',
      iAction: 3
    },
    {
      strTitle: 'خروج',
      strImage: '../../../../assets/imgs/logout.png',
      routerLink: '/partners/dashboard',
      iAction: 1
    },
  ]
  atLeastTime: number; plateValues: string[] = ['', '', '', ''];
  isCity: boolean = false;
  showCustom_Map: boolean = false;
  showFilter: boolean = false;
  bEditMode: boolean | 'showMode' | 'searchMode' = false;
  hasUpperCase = false;
  hasLowerCase = false;
  hasNumbers = false;
  hasSpecialChars = false;
  isLongEnough = false;
  currentTime: any = moment().format('jYYYY/jMM/jDD');

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this._otherService.get_PartnerData().iSystemUser),
    strSession: new FormControl(this._otherService.get_PartnerData().strSession),
    strName: new FormControl(''), //  نام مسافر
    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 
    strMobile: new FormControl('', Validators.required), //  موبایل مسافر
    tiSex: new FormControl(1), //  جنسیت 
    strDate: new FormControl('', Validators.required), //  تاریخ سفر
    strTime: new FormControl(moment().format("HH:mm"), Validators.required), //  ساعت سفر
    strSCity: new FormControl('', Validators.required), //  شهر مبدا
    fSLon: new FormControl('', Validators.required),
    fSLat: new FormControl('', Validators.required),
    strSAddress: new FormControl('', Validators.required),
    strDCity: new FormControl('', Validators.required), //  شهر مقصد
    fDLon: new FormControl('0'),
    fDLat: new FormControl('0'),
    strDAddress: new FormControl(''),
    bCameBack: new FormControl(false), //  دارای برگشت 
    bHasStop: new FormControl(false), //  داری توقف
    fEstimateStop: new FormControl(''), //  مدت توقف مثلا 3.5 ساعت 
    tiPassenger: new FormControl(1), //  تعداد مسافر
    bCargo: new FormControl(false), //  بار دارد
    strCargoDetail: new FormControl(''), //  توضیحات بار
    bPet: new FormControl(false), //  حیوان خانگی 
    bSmoking: new FormControl(false), //  سیگار مجاز
    bNeedHelp: new FormControl(false), //  نیاز به کمک 
    bInvoiceRequired: new FormControl(false), //  نیاز به فاکتور
    strCompany: new FormControl(''), //  اسم شرکت برای فاکتور
    bForeigner: new FormControl(false), //  مسافر غیر ایرانی
    strPassportNumber: new FormControl(''), //  شماره پاسپورت مسافر غیر ایرانی 
    strComment: new FormControl(''), //  توضیحات
    tiMobileGroup: new FormControl('', Validators.required), //  گروه خودرویی
    iEstimateRent: new FormControl({ value: 0 }, Validators.required), // کرایه
    iPartnerRent: new FormControl(0, Validators.required), //  کرایه اعلام شده
    iPartnerReceived: new FormControl(0, Validators.required), //  کرایه دریافت شده
    fEstimateKm: new FormControl(''), //  مسافت
    _fKm: new FormControl(''), //  مسافت
    _strTime: new FormControl(''), //  مدت زمان سفر

  });
  mdl_TripSAD: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this._otherService.get_PartnerData().iSystemUser),

    strSession: new FormControl(this._otherService.get_PartnerData().strSession),

    strName: new FormControl(''), //  نام مسافر

    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 

    strMobile: new FormControl('', Validators.required), //  موبایل مسافر

    tiMobileType: new FormControl('-1', Validators.required), // نوع خودرو 

    tiReason4Request: new FormControl('-1', Validators.required), // علت درخواست 

    tiReliefRequestType: new FormControl('-1', Validators.required), // نوع درخواست امداد 

    strReasonStopping: new FormControl(''), // دلیل توقف   

    tiMobileGroup: new FormControl('', Validators.required), // نوع جرثقیل 

    strSCity: new FormControl('', Validators.required), // شهر مبدا

    strSAddress: new FormControl('', Validators.required), // آدرس مبداء

    fSLat: new FormControl(0, Validators.required), // موقعیت مبدا

    fSLon: new FormControl(0, Validators.required), // موقعیت مبدا

    strDCity: new FormControl(''), // شهر مقصد

    strDAddress: new FormControl(''), // آدرس مقصد

    fDLat: new FormControl(0), // موقعیت مقصد

    fDLon: new FormControl(0), // موقعیت مقصد

    strDate: new FormControl(this.persianNumber.toEnglish(new Date().toLocaleString('fa-ir')), Validators.required), // تاریخ

    strTime: new FormControl('', Validators.required), // ساعت

    bTraffic: new FormControl(false), // چک باکس طرح ترافیک

    bEvenOdd: new FormControl(false), // چک باکس طرح آلودگی 

    bBadWeather: new FormControl(false), // چک باکس شرایط آب وهوایی ویژه 

    bMountainous: new FormControl(false), // چک باکس منطقه کوهستانی 

    strComment: new FormControl(''), // توضیحات

    strVehicleNo: new FormControl(''), // پلاک

    strVehicleNo_1: new FormControl(''),

    strVehicleNo_2: new FormControl(''),

    strVehicleNo_3: new FormControl(''),

    strVehicleNo_4: new FormControl(''),

    iFixCost: new FormControl(0, Validators.required), //  کرایه اعلام شده

    iPartnerRent: new FormControl(0), //  کرایه اعلام شده

    iPartnerReceived: new FormControl(0), //  کرایه دریافت شده

    fEstimateKm: new FormControl(''), //  مسافت

    _fKm: new FormControl(''), //  مسافت

    _strTime: new FormControl(''), //  مدت زمان سفر

  });
  mdl_Map: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  });
  mdl_PW: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this._otherService.get_PartnerData().iSystemUser),

    strSession: new FormControl(this._otherService.get_PartnerData().strSession),

    currentPassword: ['', Validators.required],

    newPassword: ['', [Validators.required, Validators.minLength(4)]],

    confirmPassword: ['', Validators.required]

  });

  constructor(

    private _router: Router,

    private _route: ActivatedRoute,

    private FormBuilder: FormBuilder,

    private _otherService: OtherService,

    public loaderService: BusyService,

    private _service: AccountService,

    private _MapService: MapService,

    private persianNumber: PersianNumberService,

  ) { }

  ngOnInit(): void {

    this._otherService.setTitle('امدادران | پنل همکاران');

    this.city_TaxiLon();

    this.getMobileGroup();

    this.getAtleastTime();

  }

  ngOnDestroy() {

    // this._otherService.setTitle('');

    $("#newReq_Modal").modal("hide");

    $("#PW_Modal").modal("hide");


  }

  showAction(iAction: 1 | 2) {

    if (iAction == 1) {

      Swal.fire({

        title: "آیا قصد خروج از حساب کاربری خود را دارید؟",

        icon: 'warning',

        iconHtml: '?',

        showCancelButton: true,

        showConfirmButton: true,

        reverseButtons: true,

        confirmButtonColor: '#10b981',

        cancelButtonColor: '#EF4444',

        confirmButtonText: 'تایید',

        cancelButtonText: 'لغو',

      }).then((result) => {

        if (result.isConfirmed) {

          window.localStorage.removeItem('db31a17f18d1a8a3l0ifrEz8abJb02');

          this._router.navigateByUrl('/partners');

        }

      })

    }

    else if (iAction == 2) {

      this.mdl_TripSAD.patchValue({

        strName: '', //  نام مسافر

        strFamily: '', //  فامیل مسافر 

        strMobile: '', //  موبایل مسافر

        tiMobileType: -1, // نوع خودرو 

        tiReason4Request: -1, // علت درخواست 

        tiReliefRequestType: -1, // نوع درخواست امداد 

        strReasonStopping: '', // دلیل توقف   

        tiMobileGroup: '', // نوع جرثقیل 

        strSCity: '', // شهر مبدا

        strSAddress: '', // آدرس مبداء

        fSLat: 0, // موقعیت مبدا

        fSLon: 0, // موقعیت مبدا

        strDCity: '', // شهر مقصد

        strDAddress: '', // آدرس مقصد

        fDLat: 0, // موقعیت مقصد

        fDLon: 0, // موقعیت مقصد

        strDate: moment().format("jYYYY/jMM/jDD"), // تاریخ

        strTime: moment().format("HH:mm"), // ساعت

        bTraffic: false, // چک باکس طرح ترافیک

        bEvenOdd: false, // چک باکس طرح آلودگی 

        bBadWeather: false, // چک باکس شرایط آب وهوایی ویژه 

        bMountainous: false, // چک باکس منطقه کوهستانی 

        strComment: '', // توضیحات

        strVehicleNo: '', // پلاک

        strVehicleNo_1: '',

        strVehicleNo_2: '',

        strVehicleNo_3: '',

        strVehicleNo_4: '',

        iFixCost: 0, //  کرایه اعلام شده

        iPartnerReceived: 0, //  کرایه دریافت شده

        fEstimateKm: '', //  مسافت

        _fKm: '', //  مسافت

        _strTime: '', //  مدت زمان سفر

      });

      $("#newReq_Modal").modal("show");

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

    else if (iAction == 3) {

      $("#PW_Modal").modal("show");


    }

  }

  city_TaxiLon = async () => {

    if (!this._service.list_StoredCity.length) {

      this.loaderService.busy();

      let res = JSON.parse((await axios.post(`TaxiLon_City_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data);

      if (res.bError || res.iResult == 0) {

        this.loaderService.idle();

        return this._service.toastSwal('error', res.strError);

      }

      this.list_City = res;

      this._service.list_StoredCity = res;

    }

    else {

      this.list_City = this._service.list_StoredCity;

    }

    // ------------------------------------------------------------- >

    if (!this._service.list_StoredCategory.length) {

      const resp = await axios.post(`GetMobileGroup`, {});

      resp.data = JSON.parse(resp.data);

      this.loaderService.idle();

      if (resp.data.bError || resp.data.iResult == 0) return this._service.toastSwal('error', resp.data.strError);

      this.lst_GroupCar = resp.data;

      this._service.list_StoredCategory = this.lst_GroupCar;

    }

    else {

      this.lst_GroupCar = this._service.list_StoredCategory;

    }


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  setValue_Filter(event: any, strKey: string) {

    if (event?.strCityName) {

      if (strKey == 'strSCity') {

        this.mdl_TripSAD.patchValue({

          strSCity: event.strCity,

          fSLon: event.fLon,

          fSLat: event.fLat,

        });
      }

      else {
        this.mdl_TripSAD.patchValue({
          strDCity: event.strCity,

          fDLon: event.fLon,

          fDLat: event.fLat,
        });
      }
    }

    else {
      if (strKey == 'strSCity') {
        this.mdl_TripSAD.patchValue({
          strSCity: '',

          fSLon: '',

          fSLat: '',
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strDCity: '',

          fDLon: '',

          fDLat: '',
        });
      }
    }
  }

  show_Map(mdl_Type: 'strSAddress' | 'strDAddress') {

    if (mdl_Type == 'strSAddress') {

      if (this.mdl_TripSAD.get('strSCity')?.value.trim() == '') return this._service.toastSwal('error', 'شهر مبداء را انتخاب کنید');

      if (this.mdl_TripSAD.get('strSAddress')?.value.trim() == '' && this.mdl_TripSAD.get('fSLat')?.value == 0) {

        this._MapService.getCurrentLocation().then(coords => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

            fLon: coords.longitude,

            fLat: coords.latitude,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

        }).catch(error => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

            fLon: this.mdl_TripSAD.get('fSLon')?.value,

            fLat: this.mdl_TripSAD.get('fSLat')?.value,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

          console.error('Error getting location:', error);

        });


      }

      else {

        let cityName = this.returnStrValue('strCity', this.mdl_TripSAD.get('strSCity')?.value, this.list_City, 'strCityName');

        let address = !this.mdl_TripSAD.get('strSAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_TripSAD.get('strSAddress')?.value : this.mdl_TripSAD.get('strSAddress')?.value;

        this.mdl_Map.patchValue({

          strAddress: this.mdl_TripSAD.get('strSAddress')?.value != '' ? address : '',

          fLon: this.mdl_TripSAD.get('fSLon')?.value,

          fLat: this.mdl_TripSAD.get('fSLat')?.value,

          strSource: 'strSAddress',

        });

        this.showCustom_Map = true;


      }

    }

    else {

      if (this.mdl_TripSAD.get('strDAddress')?.value.trim() == '') return this._service.toastSwal('error', 'شهر مقصد را انتخاب کنید');

      if (this.mdl_TripSAD.get('strDAddress')?.value.trim() == '' && this.mdl_TripSAD.get('fDLon')?.value == 0) {

        this._MapService.getCurrentLocation().then(coords => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strDAddress')?.value,

            fLon: coords.longitude,

            fLat: coords.latitude,

            strSource: 'strDAddress',

          });

          this.showCustom_Map = true;

        }).catch(error => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strDAddress')?.value,

            fLon: this.mdl_TripSAD.get('fDLon')?.value,

            fLat: this.mdl_TripSAD.get('fDLat')?.value,

            strSource: 'strDAddress',

          });

          this.showCustom_Map = true;

          console.error('Error getting location:', error);

        });


      }

      else {

        let cityName = this.returnStrValue('strCity', this.mdl_TripSAD.get('strDCity')?.value, this.list_City, 'strCityName');

        let address = !this.mdl_TripSAD.get('strDAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_TripSAD.get('strDAddress')?.value : this.mdl_TripSAD.get('strDAddress')?.value;

        this.mdl_Map.patchValue({

          strAddress: this.mdl_TripSAD.get('strDAddress')?.value != '' ? address : '',

          fLon: this.mdl_TripSAD.get('fDLon')?.value,

          fLat: this.mdl_TripSAD.get('fDLat')?.value,

          strSource: 'strDAddress'

        })

        this.showCustom_Map = true;

      }

    }

  }

  submitMap(event: any) {
    this.showCustom_Map = false;

    if (this.mdl_Map.get('strSource')?.value == 'strSAddress') {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strSAddress: event.strText,

          fSLon: event.longitude,

          fSLat: event.latitude,
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strSAddress: '',

          fSLon: '',

          fSLat: '',
        });
      }
    } else {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,
        });
      } else {
        this.mdl_TripSAD.patchValue({
          strDAddress: '',

          fDLon: '',

          fDLat: '',
        });
      }
    }
  }

  reset_calc() {

    this.mdl_Request.patchValue({

      iEstimateRent: 0,

      _fKm: '',

      _strTime: ''

    })

  }

  putSeparator(number: number | string, mode: 'showMode' | 'searchMode' | boolean): string | number {

    if (mode == 'showMode' || mode) {

      return number.toLocaleString();

    }

    else {
      return number
    }

  }

  calc_Renting = async () => {

    let model = this._otherService.stringNumberToNumber(this.mdl_Request.value);

    if (this.isCity ? this.calcValidity() : (model.tiMobileGroup == '' || model.strSCity == '' || model.strDCity == '')) return this._service.toastSwal('error', 'لطفا فرم را با دقت تکمیل کنید');

    this.loaderService.busy();

    let res = JSON.parse((await axios.post(`TaxiLon_ORG_TravelCostEstimate`, model)).data);

    this.loaderService.idle();

    this.mdl_Request.patchValue({

      iEstimateRent: res.iRent.toLocaleString(),

      iFixCost: 0,

      iPartnerReceived: 0,

      fEstimateKm: res.fKm,

      _fKm: res.fKm.toLocaleString() + ' کیلومتر ',

      _strTime: res.strTime

    })

  }

  calcValidity() {

    const requiredFields = [

      { key: "fSLon", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "fSLat", isValid: (value: any) => value !== '' && value !== 0 },

      { key: "strSAddress", isValid: (value: any) => value !== '' },

      { key: "strDCity", isValid: (value: any) => value !== '' },

      { key: "tiMobileGroup", isValid: (value: any) => value !== '' },

    ];

    return requiredFields.some(field => !field.isValid(this.mdl_Request.value[field.key]));

  }

  search_ByMobile = async () => {
    let model = this._otherService.stringNumberToNumber(this.mdl_TripSAD.value);

    if (model.strMobile == '' || model.strMobile.length != 11) {
      return this._service.toastSwal('error', 'شماره موبایل را به درستی وارد کنید');
    }

    this.loaderService.busy();
    let response = JSON.parse((await axios.post(`TaxiLon_User_Info4Manager`, model)).data);
    this.loaderService.idle();
    let res = response[0] ?? response;

    this.bEditMode = 'searchMode';
    setTimeout(() => {
      this.bEditMode = false;
    }, 1000);

    if (res.bError || res.iResult == 0) {
      return this._service.toastSwal('error', res.strError);
    }

    if (res?.strName) {
      this.mdl_TripSAD.patchValue({
        strName: res.strName, //  نام مسافر
        strFamily: res.strFamily, //  فامیل مسافر 
        strSCity: res.strCity, //  شهر مبدا
        fSLon: res.fLat > 0 ? res.fLat : this.get_latLong(res.strCity, 'fLat'),
        fSLat: res.fLon > 0 ? res.fLon : this.get_latLong(res.strCity, 'fLon'),
        strSAddress: res.strAddress,
      });

      if (res?.strVehicleNo) {
        const [first, second, third, pipe, fourth] = res?.strVehicleNo.split(' ');
        this.mdl_TripSAD.patchValue({
          strVehicleNo_1: first,
          strVehicleNo_2: second,
          strVehicleNo_3: third,
          strVehicleNo_4: fourth
        })
      }

      // Rerender custom-filter
      this.showFilter = false;
      setTimeout(() => {
        this.showFilter = true;
      }, 10);
    }

    else {
      this.mdl_TripSAD.patchValue({
        strName: '', //  نام مسافر
        strFamily: '', //  فامیل مسافر 
        strSCity: '', //  شهر مبدا
        fSLon: '',
        fSLat: '',
        strSAddress: '',
        strVehicleNo_1: '',
        strVehicleNo_2: '',
        strVehicleNo_3: '',
        strVehicleNo_4: ''
      })

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

  }

  get_latLong(strCity: number | string, target: 'fLon' | 'fLat'): number {

    return this.list_City.filter((el: any) => { return el.strCity == strCity })[0][target];

  }

  submit_Request = async () => {

    let model = this.mdl_TripSAD.value;

    if (this.mdl_TripSAD.invalid) return this._service.toastSwal('error', '!لطفا موارد ستاره دار را وارد کنید');

    if (this.mdl_TripSAD.get('strDate')?.value < moment().format("jYYYY/jMM/jDD")) {

      return this._service.toastSwal('error', 'تاریخ سفر نمی تواند گذشته باشد')

    }

    if (false && this.mdl_Request.get('iPartnerRent')?.value < this.mdl_Request.get('iEstimateRent')?.value) {

      return this._service.toastSwal('error', 'کرایه اعلام شده، کمتر از کرایه سفر می باشد')

    }

    if (false && this.mdl_Request.get('iPartnerReceived')?.value > this.mdl_Request.get('iPartnerRent')?.value) {

      return this._service.toastSwal('error', 'مبلغ دریافتی، بیشتر از کرایه اعلامی می باشد')

    }

    if (model.strTime.trim() == '') return this._service.toastSwal('error', 'ساعت را وارد کنید');

    if (model.strVehicleNo_1.trim() == '' || model.strVehicleNo_2.trim() == '' || model.strVehicleNo_3.trim() == '' || model.strVehicleNo_4.trim() == '') return this._service.toastSwal('error', 'پلاک خودرو را وارد کنید');

    if (model.strDate < this.currentTime) return this._service.toastSwal('error', 'تاریخ قبل از امروز را نمی توانید انتخاب کنید');

    if (model.strSCity == '') return this._service.toastSwal('error', 'شهر مبدا را وارد کنید');

    if (model.strSAddress == '') return this._service.toastSwal('error', 'آدرس مبدا را وارد کنید');

    if (model.fSLon == '') return this._service.toastSwal('error', 'موقعیت مبدا را وارد کنید');

    if (model.tiMobileType == '-1') return this._service.toastSwal('error', 'نوع خودرو را مشخص کنید');

    if (model.tiReliefRequestType == '-1') return this._service.toastSwal('error', 'نوع درخواست را مشخص کنید');

    if (model.tiReason4Request == '-1') return this._service.toastSwal('error', 'علت درخواست را مشخص کنید');

    if (model.tiMobileGroup == '-1') return this._service.toastSwal('error', 'نوع نوع جرثقیل را مشخص کنید');

    if (model.strVehicleNo_1) {

      model.strVehicleNo = model.strVehicleNo_1 + ' ' + model.strVehicleNo_2 + ' ' + model.strVehicleNo_3 + ' | ' + model.strVehicleNo_4;

    }

    let showConfirmationDialog = (message: string, model: any) => {

      Swal.fire({

        title: "آیا از ثبت درخواست حمل اطمینان دارید ؟",

        icon: 'warning',

        iconHtml: '?',

        html: message,

        showCancelButton: true,

        reverseButtons: true,

        confirmButtonColor: '#10b981',

        cancelButtonColor: '#EF4444',

        confirmButtonText: 'تایید',

        cancelButtonText: 'لغو',

      }).then((result) => {

        if (result.isConfirmed) {

          this._service.EmdadRo_Partner_Save(this._otherService.stringNumberToNumber(model)).subscribe((data: any) => {

            let res = JSON.parse(data.toString());

            if (res.iResult === 0) return this._service.toastSwal('error', res.strError);

            this._service.toastSwal('success', `درخواست شما با کد ${res[0].iEmdadRo} ثبت گردید و بزودی به آن رسیدگی بعمل می آید`, 6000);

            $("#newReq_Modal").modal('hide')

          });

        }

      });

    }

    if (model.fSLon && model.fSLat && this.isUser_OpenedMap()) {

      this._service.TaxiLon_User_TravelCostEstimate(this._otherService.stringNumberToNumber(model)).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if (res.iResult === 0) return this._service.toastSwal('error', res.strError);

        let message = res.iRent ? `

              <p class="fs-6"> مسافت : <strong> ${res.fKm.toLocaleString()} کیلومتر  </strong> </p>

              <p class="fs-6"> هزینه حمل(ریال) : <strong> ${res.iRent.toLocaleString()} </strong> </p>

              <p class="fs-6"> مبلغ پیش پرداخت (ریال) : <strong> ${res.iAdvancePayment.toLocaleString()} </strong> </p> ` : '';

        showConfirmationDialog(message, model);

      });

    }

    else {

      showConfirmationDialog('', model);

    }

  }

  isUser_OpenedMap(): boolean {

    let model = this.mdl_TripSAD.value;

    if (!model.fDLon || !model.fDLat) {

      return false;

    }

    else if (model.fDLon && model.fDLat) {

      return !Boolean(this.list_City.find((el) => (el.fLat == model.fDLat && el.fLon && model.fDLon)))

    }

  }

  checkPasswordStrength() {

    const password = this.mdl_PW.get('newPassword')?.value || '';

    this.hasUpperCase = /[A-Z]/.test(password);

    this.hasLowerCase = /[a-z]/.test(password);

    this.hasNumbers = /\d/.test(password);

    this.hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    this.isLongEnough = password.length >= 8;

    const strengthScore = (this.hasUpperCase ? 1 : 0) + (this.hasLowerCase ? 1 : 0) + (this.hasNumbers ? 1 : 0) + (this.hasSpecialChars ? 1 : 0) + (this.isLongEnough ? 1 : 0);

    if (strengthScore <= 2) {

      this.passwordStrength = 'weak';

      this.passwordStrengthMessage = 'رمز عبور ضعیف است (طولانی‌ تر و پیچیده‌ تر کنید)';

    }

    else if (strengthScore === 3) {

      this.passwordStrength = 'medium';

      this.passwordStrengthMessage = 'رمز عبور متوسط است (بهبود دهید)';

    }

    else if (strengthScore === 4) {

      this.passwordStrength = 'strong';

      this.passwordStrengthMessage = 'رمز عبور قوی است';

    }

    else if (strengthScore === 5) {

      this.passwordStrength = 'very-strong';

      this.passwordStrengthMessage = 'رمز عبور بسیار قوی است';

    }

  }

  submit_Password = async () => {

    if (!this.mdl_PW.get('currentPassword').valid) return this._service.toastSwal('error', 'رمز عبور فعلی را وارد کنید');

    if (!this.mdl_PW.get('newPassword').valid) return this._service.toastSwal('error', 'طول رمز عبور جدید باید بیشتر از 4 باشد');

    if (this.mdl_PW.invalid) return this._service.toastSwal('error', 'موارد ستاره دار را وارد کنید');

    if (this.mdl_PW.get('newPassword')?.value != this.mdl_PW.get('confirmPassword')?.value) return this._service.toastSwal('error', 'رمز عبور و تکرار رمز عبور مطابقت ندارند');

    else {

      let model = {

        iSystemUser: this._otherService.get_PartnerData().iSystemUser,

        strSession: this._otherService.get_PartnerData().strSession,

        strOldPassword: this.mdl_PW.get('currentPassword')?.value,

        strNewPassword: this.mdl_PW.get('newPassword')?.value

      }

      this.loaderService.busy();

      let res = JSON.parse((await axios.post(`TaxiLon_Trip_Partner_ChangePassword`, model)).data);

      this.loaderService.idle();

      if (res.bError || res.iResult == 0) return this._service.toastSwal('error', res.strError);

      $("#PW_Modal").modal("hide");

      this._service.toastSwal('success', 'تغییر رمز عبور با موفقیت انجام شد')


    }


  }

  getMobileGroup = async () => {

    this._service.getMobileType().subscribe((data: any) => {

      this.list_MobileType = data;

    });

    this._service.getMobileGroup().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_MobileGroup = res;

    });

    this._service.getReason4Request().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_Reason = res;


    });

    this._service.getReliefType().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_ReliefType = res;

    });


  }

  getAtleastTime() {

    this._service.TaxiLon_AtLeastTime().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.atLeastTime = res;

      this.mdl_TripSAD.patchValue({

        strTime: moment().format("HH:mm")

      })

    });

  }

  
  filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }

}
